import React from 'react';
import OverviewHelp from './OverviewHelp';
import CatalogHelp from './CatalogHelp';
import LineageHelp from './LineageHelp';
import RunsHelp from './RunsHelp';
import EventsHelp from './EventsHelp';
import ImpactHelp from './ImpactHelp';

interface DataOpsHelpProps {
  activeTab?: string;
}

/**
 * DataOps Help - Context-aware help content switcher
 * Displays relevant help content based on the currently active tab
 */
const DataOpsHelp: React.FC<DataOpsHelpProps> = ({ activeTab }) => {
  switch (activeTab) {
    case 'overview':
      return <OverviewHelp />;
    case 'catalog':
      return <CatalogHelp />;
    case 'lineage':
      return <LineageHelp />;
    case 'runs':
      return <RunsHelp />;
    case 'events':
      return <EventsHelp />;
    case 'impact':
      return <ImpactHelp />;
    default:
      return <OverviewHelp />;
  }
};

export default DataOpsHelp;
